import React, {Suspense} from 'react';
import {MixModel, ProjectDataIndex, ProjectTab} from '../../../api/types.ts';

// Blockly is ~1MB — only load it when a Blocks tab is actually opened.
const BlocksEditor = React.lazy(() => import('../../blocks/BlocksEditor.tsx'));

interface ProjectTabBlocksProps {
    mix: MixModel;
    tab: ProjectTab;
    dataIndex: ProjectDataIndex;
    readOnly: boolean;
    isFocusMode?: boolean;
    onEnterFocusMode?: () => void;
    onExitFocusMode?: () => void;
}

const ProjectTabBlocks: React.FC<ProjectTabBlocksProps> = ({
    mix,
    dataIndex,
    readOnly,
    isFocusMode,
    onEnterFocusMode,
    onExitFocusMode
}) => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <BlocksEditor
                project={mix}
                dataIndex={dataIndex}
                readOnly={readOnly}
                isFocusMode={isFocusMode}
                onEnterFocusMode={onEnterFocusMode}
                onExitFocusMode={onExitFocusMode}
            />
        </Suspense>
    );
};

export default ProjectTabBlocks;
